import React, { Component } from 'react';
import glamorous from 'glamorous';
import 'glamor/reset';

import Header from './components/Header';
import { Container } from './components/Layout';
import About from './components/About';
import Experience from './components/Experience';
import Education from './components/Education';
import Footer from './components/Footer';

class App extends Component {
  render() {
    return (
      <AppContainer>
        <Body>
          <Header />
          <Container>
            <About />
            <Experience />
            <Education />
          </Container>
        </Body>

        <Footer />
      </AppContainer>
    );
  }
}

export default App;

const AppContainer = glamorous.div({
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column'
});

const Body = glamorous.div({
  flex: '1'
});



// WEBPACK FOOTER //
// ./src/App.js